import React from 'react'
import classes from './pose-img.module.sass'

const TwoPoseGrid = ({ items }) => (
  <div className={classes.poses2}>
    {items[0]}
    <div>{items[1]}</div>
  </div>
)

export default TwoPoseGrid
